import { z } from "zod";
import { userRoleSchema } from "../../enums/user-role.js";

export const updateUserSchema = z.object({
	first_name: z.string().min(1).max(100).optional(),
	last_name: z.string().min(1).max(100).optional(),
	role: userRoleSchema.optional(),
});

export type UpdateUserPayload = z.infer<typeof updateUserSchema>;
